import { FilterTerm } from "../models/filter-term";
// collection of terms
var FilterTerms = Backbone.Collection.extend({
    model: FilterTerm,
    comparator: function( item1, item2 ){
        var sortValue = item1.get('name') > item2.get('name') ? 1 : -1;

        return sortValue;
    } 
});
export {FilterTerms};